module.exports = __webpack_public_path__ + "img/inactivar_tx.841364ca.svg";